import { useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useDashboard } from '../../context/DashboardContext';

// Relie le sélecteur d'entreprise (DashboardContext) aux limites appliquées (AuthContext) :
// un utilisateur de plusieurs entreprises voit le forfait de celle où il TRAVAILLE, pas celui de
// sa 1re adhésion. Superadmin : rien ne change (ses droits ne dépendent d'aucune entreprise).
export function ActiveEnterpriseSync(): null {
  const { enterpriseId } = useDashboard();
  const { user, selectEnterprise } = useAuth();
  const eligible = user.loggedIn && user.role !== 'superadmin';

  useEffect(() => {
    void selectEnterprise?.(eligible && enterpriseId ? enterpriseId : null);
  }, [eligible, enterpriseId, selectEnterprise]);

  return null;
}
